import { render, staticRenderFns } from "./ClientRoleAssignments.vue?vue&type=template&id=ca6303a4&"
import script from "./ClientRoleAssignments.vue?vue&type=script&lang=js&"
export * from "./ClientRoleAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports